const DEFAULT_SNACKBAR_MESSAGE = 'Oops, something went wrong :(';
const DEFAULT_SNACKBAR_COLOR = 'red';

const moduleMain = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    snackbar: {
      isSnackbar: false,
      text: DEFAULT_SNACKBAR_MESSAGE,
      color: DEFAULT_SNACKBAR_COLOR,
      timerId: null
    },
    isMobileSidebar: false
  }),
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    isSnackbar(state) {
      return state.snackbar.isSnackbar;
    },
    snackbar(state) {
      return state.snackbar;
    },
    isMobileSidebar(state) {
      return state.isMobileSidebar;
    }
  },
  mutations: {
    updateLoading(state, data) {
      state.isLoading = data;
    },
    updateSnackbar(state, data) {
      state.snackbar.isSnackbar = data.isSnackbar;
      state.snackbar.text = data.text;
      state.snackbar.color = data.color;
      state.snackbar.timerId = data.timerId;
    },
    updateMobileSidebar(state, data) {
      state.isMobileSidebar = data;
    }
  },
  actions: {
    async startLoading({ commit }) {
      commit('updateLoading', true);
    },
    async stopLoading({ commit }) {
      commit('updateLoading', false);
    },
    async showSnackbar({ commit }, { text = DEFAULT_SNACKBAR_MESSAGE, color = DEFAULT_SNACKBAR_COLOR } = {}) {
      const timerId = setTimeout(() => {
        commit('updateSnackbar', { isSnackbar: false });
      }, 5000);
      commit('updateSnackbar', { text, color, isSnackbar: true, timerId });
    },
    async hideSnackbar({ commit, state }) {
      commit('updateSnackbar', { isSnackbar: false });
      if (state.snackbar.timerId) clearTimeout(state.snackbar.timerId);
    },
    // if the desktop version, call the action without parameters
    // and isMobileSidebar is set to true => the sidebar is visible
    async toggleMobileSidebar({ commit }, isSidebarShown = false) {
      commit('updateMobileSidebar', !isSidebarShown);
    }
  }
};

export default moduleMain;
